export default "__VITE_ASSET__Bc2xm4te__"